import {Box, Typography, styled, useTheme} from '@mui/material';
import {
  BottomSheet as BtmSheet,
  BottomSheetRef,
  BottomSheetProps,
} from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import {Image} from '@jobseeker/lotus/components/Image';
import {CrossOutlined as Cross, WhiteCrossOutlined as WhiteCross} from '@jobseeker/lotus/icons';
const BottomSheet = styled(BtmSheet)<any>(props => ({
  '& [data-rsbs-overlay],[data-rsbs-backdrop]': {
    zIndex: 9999,
  },
  '&::after': {
    zIndex: 9999,
  },
  '& [data-rsbs-header]': {
    ...props.headerStyles,
    overflow: 'hidden',
  },
  '& [data-rsbs-footer]': {
    padding: 0,
    overflow: 'hidden',
    textAlign: 'left',
    border: 'none',
    boxShadow: 'none',
  },
}));

type BottomSheetMapProps = BottomSheetProps & {
  bannerMode?: boolean;
  titleExtension?: string;
  headerStyles?: any;
};

export default ({
  children,
  headerStyles = {},
  ...props
}: BottomSheetMapProps) => {
  const theme = useTheme();
  return (
    <BottomSheet
      // open={expand}
      // onDismiss={toggleAcordion}
      maxHeight={props?.maxHeight}
      header={
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            cursor: 'default',
            alignItems: 'flex-start',
            gap: 1,
            paddingBottom: '1px',
            ...headerStyles,
          }}
        >
          <Typography
            variant="subtitle2"
            color={props?.bannerMode ? 'white' : 'secondary'}
            textAlign={props?.titleExtension ? 'left' : 'center'}
            style={{
              fontSize: props?.titleExtension ? 16 : 14,
              fontWeight: props?.titleExtension ? 600 : 500,
            }}
          >
            {props.title ?? 'Update Profile'}
            {props?.titleExtension && (
              <>
                <br />
                <Typography
                  fontSize={theme.typography.pxToRem(16)}
                  fontWeight={theme.typography.fontWeightBold}
                  sx={{
                    background: theme.palette.pro.main,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 0.5,
                  }}
                >
                  {props.titleExtension}
                </Typography>
              </>
            )}
          </Typography>
          <Image
            src={props?.bannerMode ? WhiteCross : Cross}
            alt={'Close Icon'}
            width={18}
            height={18}
            onClick={props.onDismiss}
            objectFit="cover"
            style={{cursor: 'pointer'}}
          />
        </Box>
      }
      snapPoints={({maxHeight, ...other}: any) =>
        [
          maxHeight - maxHeight * 0.1,
          maxHeight - maxHeight * 0.3,
          maxHeight - maxHeight * 0.6,
        ].concat(
          props.snapPoints ? props.snapPoints({maxHeight, ...other}) : []
        )
      }
      defaultSnap={({lastSnap, snapPoints}: any) =>
        lastSnap ?? Math.max(...snapPoints)
      }
      {...props}
      headerStyles={
        props.header
          ? {
              padding: 0,
              textAlign: 'left',
              ...headerStyles,
            }
          : props?.bannerMode
          ? {
              background: 'linear-gradient(90deg, #225448 0%, #7E9F67 100%)',
              borderRadius: '16px 16px 0 0',
              paddingBottom: 16,
              ...headerStyles,
            }
          : {
              ...headerStyles,
            }
      }
    >
      {children}
    </BottomSheet>
  );
};
